enum ModalBodyType {
  LEGAL = 'SMS_OPT_IN_LEGAL',
  VERIFICATION = 'VERIFICATION_CODE',
  SUCCESS = 'SMS_OPT_IN_SUCCESS',
}

export default ModalBodyType;
